/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';

import { JobChecklistDto, JobChecklistProduceDto } from './job-checklists.dto';
import { JobChecklistMapper } from './job-checklists.mapper';

@Injectable()
export class JobChecklistsRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<JobChecklistDto> {
    return this.httpGet(
      `/jobs/${jobId}/checklists`,
      JobChecklistMapper,
    );
  }

  produce(jobId: ID, checklistId: ID): Observable<JobChecklistProduceDto> {
    return this.httpPut(`/jobs/${jobId}/checklists/${checklistId}/produce`, void 0, none(), identity());
  }

  generateImage(jobId: ID, checklistId: ID): Observable<JobChecklistProduceDto> {
    return this.httpPost(`/jobs/${jobId}/checklists/${checklistId}/generate-images`, void 0, none(), identity());
  }
}
